import { useCallback } from "react";

import { FormInstance } from "antd/es/form";
import { useHistory } from "react-router-dom";

import Located from "@mapmycustomers/shared/types/base/Located";
import { Person } from "@mapmycustomers/shared/types/entity";

import RecordPaneTab from "@app/enum/preview/RecordPaneTab";

import DetailsFormValues from "../Details/DetailsFormValues";
import { updatePerson } from "../store/actions";
import personToFormValues from "../utils/personToFormValues";

const useHandleAddressChange = (
  person: Person | undefined,
  detailsForm: FormInstance<DetailsFormValues>,
  isMapMode: boolean,
  onUpdatePerson: typeof updatePerson.request,
  onUpdatePersonSuccess: typeof updatePerson.success
) => {
  const history = useHistory();

  return useCallback(
    (located: Located) => {
      history.push(RecordPaneTab.DETAILS);
      if (isMapMode) {
        const updatedPerson = located as Person;
        onUpdatePersonSuccess({ person: updatedPerson });
        const updatedFormValues = personToFormValues(updatedPerson);
        const customFields = updatedFormValues.customFields;
        const customFormFields = Object.keys(customFields ?? {}).map((key) => ({
          errors: [],
          name: ["customFields", key],
          touched: false,
          value: customFields?.[key as keyof DetailsFormValues["customFields"]],
        }));
        const fields = Object.keys(updatedFormValues).map((key) => ({
          name: key,
          touched: false,
          value: updatedFormValues[key as keyof DetailsFormValues],
        }));
        detailsForm.setFields([...fields, ...customFormFields]);
      } else {
        const addressDetails = {
          ...located,
          country: located.country ?? undefined,
          countryCode: located.countryCode ?? undefined,
        };
        if (person) {
          onUpdatePerson({
            callback: (updatedPerson: Person) => {
              const { addressDetails, latitude, longitude } = personToFormValues(updatedPerson);
              // only update address fields without touching other, possibly changed, form fields
              detailsForm.setFieldValue("addressDetails", addressDetails);
              detailsForm.setFieldValue("latitude", latitude);
              detailsForm.setFieldValue("longitude", longitude);
            },
            person: { id: person.id, ...addressDetails },
            // not providing a layoutId here because we wanna make a partial update
          });
        }
      }
    },
    [history, isMapMode, onUpdatePersonSuccess, detailsForm, person, onUpdatePerson]
  );
};

export default useHandleAddressChange;
